// @flow
import React from 'react'
import i18n from 'i18next'
import Item from './Item'
import Cart from './Cart'
import { Wrapper, Box, Title, List, Button } from './styles'

type Props = {
  canGoToNextStep?: boolean,
  nextStepText?: string,
  onNextStepClick: Function,
  products: Array<{ name: string, image: string }>,
  shouldHideDeliveryCosts?: boolean,
  showCart?: boolean,
  showNextStepButton?: boolean,
  total: number,
  totalDiscounts: number,
  totalProducts: number,
  totalShipping: number
}

const Summary = (props: Props) => (
  <Wrapper>
    <Box>
      <Title>{i18n.t('checkout.cartSummary')}</Title>
    </Box>
    <List>
      <Box>
        <Item
          text={i18n.t('checkout.totalProducts')}
          value={props.totalProducts}
        />
      </Box>
      <Box>
        <Item
          text={i18n.t('checkout.totalDiscounts')}
          value={props.totalDiscounts}
        />
      </Box>
      {!props.shouldHideDeliveryCosts && (
        <Box>
          <Item
            text={i18n.t('checkout.totalShipping')}
            value={props.totalShipping}
            hasFreeLabel
          />
        </Box>
      )}
      <Box>
        <Item bold text={i18n.t('checkout.totalOrder')} value={props.total} />
      </Box>
    </List>

    {props.showCart && <Cart products={props.products} />}

    {props.showNextStepButton && (
      <Button
        disabled={!props.canGoToNextStep}
        onClick={() => props.onNextStepClick()}
      >
        {props.nextStepText}
      </Button>
    )}
  </Wrapper>
)

Summary.defaultProps = { showNextStepButton: true }

export default Summary
